import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ProjectService } from '../service/project.service';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css'],
})
export class PrintComponent implements OnInit {
  constructor(private router: Router, private projectService: ProjectService) {
    this.projectId = localStorage.getItem('projectId');
    this.showLoader = true;
    this.coverPage = false;
    this.getProjectData();
    // GET PAGE NAMES FROM LOCAL STORAGE FOR PRINTING
    this.storedNames = JSON.parse(localStorage.getItem('names'));

    for (let i = 0; i < this.storedNames.length; i++) {
      if (this.storedNames[i] === 'Cover Page') {
        this.coverPage = true;
      }
    }
  }

  // DECLARATION OF ALL VARIABLES
  storedNames: string[] = new Array();

  projectId = '';

  companyId = '';

  projectName = '';

  companyName = '';

  allEvents = [];

  showLoader: boolean;

  count = 0;

  coverPage: boolean;

  ngOnInit() {}

  // TO CHECK WHEATHER ALL DATA IS LOADED OR NOT. IT CHECK FOR ALL EVENTS, IF ALL EVENTS FIRED ONLY THEN PRINTING WILL WORK
  check(event) {
    const CoverPageArray = Array('coverEmit');
    const projectArray = Array(
      'projectEmit',
      'basicEmit',
      'projectInfoEmit',
      'YearlyEmit',
      'roomsEmit'
    );
    const budgetArray = Array('projectEmitBudget', 'budgetEmit', 'otherEmitBudget');
    const financingArray = Array(
      'projectEmitFinancing',
      'budgetEmitFinancing',
      'loanEmitFinancing'
    );
    const opexArray = Array(
      'opexEmit',
      'otherEmitOpex',
      'projectEmitOpex',
      'tenYearEmitOpex',
      'occupiedEmitOpex',
      'occupiedTenYearEmitOpex'
    );
    const cashFlowArray = Array('projectEmitCashFlow', 'cashFlowEmit');
    const appraisalArray = Array('appraisalEmit');
    const investorArray = Array(
      'projectEmitInvestor',
      'loanEmitInvestor',
      'shareholderEmitInvestor',
      'opexEmitInvestor',
      'appraisalEmitInvestor'
    );
    const financialreportArray = Array('financingreportEmit');
    const recastArray = Array('recastEmit', 'otherEmitRecast');
    const summaryArray = Array('summaryEmit', 'otherEmitSummary');
    const loanScheduleArray = Array('loanScheduleEmit');
    const demoArray = Array();

    // CONDITIONS TO CHECK FOR ONLY SELECTED PAGES
    for (let i = 0; i < this.storedNames.length; i++) {
      if (this.storedNames[i] === 'Project Data') {
        projectArray.forEach((element) => {
          demoArray.push(element);
        });
      } else if (this.storedNames[i] === 'Budget / Costs') {
        budgetArray.forEach((element) => {
          demoArray.push(element);
        });
      } else if (this.storedNames[i] === 'Financing') {
        financingArray.forEach((element) => {
          demoArray.push(element);
        });
      } else if (this.storedNames[i] === 'Operating Expenses') {
        opexArray.forEach((element) => {
          demoArray.push(element);
        });
      } else if (this.storedNames[i] === 'Cash Flow') {
        cashFlowArray.forEach((element) => {
          demoArray.push(element);
        });
      } else if (this.storedNames[i] === 'RAL Enterprise Appraisal™') {
        appraisalArray.forEach((element) => {
          demoArray.push(element);
        });
      } else if (this.storedNames[i] === 'RAL Investor Architect™') {
        investorArray.forEach((element) => {
          demoArray.push(element);
        });
      } else if (this.storedNames[i] === 'Financial Reports') {
        financialreportArray.forEach((element) => {
          demoArray.push(element);
        });
      } else if (this.storedNames[i] === 'Recast') {
        recastArray.forEach((element) => {
          demoArray.push(element);
        });
      } else if (this.storedNames[i] === 'Summary') {
        summaryArray.forEach((element) => {
          demoArray.push(element);
        });
      } else if (this.storedNames[i] === 'Cover Page') {
        CoverPageArray.forEach((element) => {
          demoArray.push(element);
        });
      } else if (this.storedNames[i] === 'Loan Schedules') {
        loanScheduleArray.forEach((element) => {
          demoArray.push(element);
        });
      }
    }

    this.allEvents.push(Object.keys(event)[0]);
    let fact = true;

    for (let i = 0; i < demoArray.length; i++) {
      if (this.allEvents.indexOf(demoArray[i]) < 0) {
        fact = false;
      }
    }

    if (fact === true) {
      const _this = this;
      setTimeout(function () {
        _this.showLoader = false;
        window.print();
        window.close();
      }, 2000);
    }
  }

  // TO GET PROJECT NAME FROM PROJECT SERVICE FROM DB
  getProjectData() {
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/print/print.component.ts